import { useMemo } from 'react';
import { OrganizationType } from 'src/constants/organizationType';

import { makeTab } from '@sravni/ugc/lib/specialOffers/helpers';
import {
  ACTIONS,
  BANK_DEFAULT_TABS_ORDER,
  COMMON_OFFERS,
  EDUCATION_DEFAULT_TABS_ORDER,
  INSURANCE_DEFAULT_TABS_ORDER,
  MFO_DEFAULT_TABS_ORDER,
} from '@sravni/ugc/lib/specialOffers/lists';
import { PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP } from '@sravni/ugc/lib/specialOffers/productTagToTab';
import { Tab } from '@sravni/ugc/lib/specialOffers/types';

import { useFilters } from '@store/hooks/filters';
import { useIsUserLogged } from '@store/hooks/users';

import { useOrganizationType } from './organizationType';

export const useGenerateTabs = (): Tab[] => {
  const isUserLogged = useIsUserLogged();
  const organizationType = useOrganizationType();
  const filters = useFilters();
  const reviewTag = useMemo(() => filters.reviewTag, [filters.reviewTag]);

  const tabs = useMemo(() => {
    const tabList = [];

    if (reviewTag) {
      const tab = PRODUCT_TAG_TO_SPECIAL_OFFERS_TABS_MAP[reviewTag.value];

      if (tab) {
        tabList.push(...tab);
      }
    }

    if (organizationType === OrganizationType.MFI) {
      tabList.push(...MFO_DEFAULT_TABS_ORDER);
    }

    if (organizationType === OrganizationType.BANK) {
      tabList.push(...BANK_DEFAULT_TABS_ORDER);
    }

    if (organizationType === OrganizationType.COURSES) {
      tabList.push(...EDUCATION_DEFAULT_TABS_ORDER);
    }

    if (organizationType === OrganizationType.BROKER) {
      tabList.push(...[makeTab(COMMON_OFFERS.brokerskoeObsluzhivanie), ...EDUCATION_DEFAULT_TABS_ORDER]);
    }

    if (organizationType === OrganizationType.NPF) {
      tabList.push(makeTab(COMMON_OFFERS.savings), ...BANK_DEFAULT_TABS_ORDER);
    }

    if (organizationType === OrganizationType.INSURANCE) {
      if (isUserLogged) {
        return [makeTab(ACTIONS.osago)];
      }
      tabList.push(...INSURANCE_DEFAULT_TABS_ORDER);
    }

    return tabList.reduce((acc, tab) => (acc.includes(tab) ? acc : [...acc, tab]), []);
  }, [isUserLogged, organizationType, reviewTag]);

  return tabs;
};
